import script from "./HomepageMuco60.vue?vue&type=script&setup=true&lang=js"
export * from "./HomepageMuco60.vue?vue&type=script&setup=true&lang=js"

import "./HomepageMuco60.vue?vue&type=style&index=0&id=d3412ef6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3412ef6"]])

export default __exports__